import { useQuery } from '@apollo/client';
import { GET_LOCATION_FEATURES_QUERY } from './location-features.query';
import {
    GetLocationFeatures,
    GetLocationFeaturesVariables,
    GetLocationFeatures_location_features,
} from './__graphqlTypes/GetLocationFeatures';

export function useLocationFeatures(
    locationId: string | null | undefined,
    // eslint-disable-next-line camelcase
): Omit<GetLocationFeatures_location_features, '__typename'> {
    const result = useQuery<GetLocationFeatures, GetLocationFeaturesVariables>(
        GET_LOCATION_FEATURES_QUERY,
        !locationId
            ? { skip: true }
            : {
                  notifyOnNetworkStatusChange: true,
                  variables: { locationId },
              },
    );
    return {
        dashboardV2: false,
        enableLocationDetailsV2: false,
        enableNewAssetLibrary: false,
        enableNewConnectPage: false,
        enableNewGalleryPage: false,
        enableNewScheduledPage: false,
        showOldEmailTemplatesOption: false,
        templateGalleryV2: false,
        ...result.data?.location?.features,
    };
}
